// Dependencies
import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { When } from "react-if";
import { useNavigate } from "react-router-dom";
import { httpsUrlValidator, removeScheme } from "../../../utils";

export default function PreLogin() {
  const [urlRaw, setUrl] = useState('');
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState('');

  const [finalUrl, setFinalUrl] = useState('');
  const [step, setStep] = useState(0);

  const navigate = useNavigate();


  
  useEffect(()=>{

  },[urlRaw]);

  const onChangeInput = useCallback((e: ChangeEvent<HTMLInputElement> )=>{
    setUrl(e.target.value);
    setError('');
    setTouched(true);
    setFinalUrl('');
    setStep(0)
  },[]);

  const onClickContinue = useCallback(()=>{
    if(!urlRaw){
      setError("Please enter a valid domain")
      return;
    }

    if(!httpsUrlValidator(urlRaw)){
      setError("Invalid URL format. Please check and try again.")
      return; 
    }

    navigate('/auth/login',{
      state: {
        url: removeScheme(urlRaw)
      }
    })
    // setFinalUrl(urlRaw);

    // setStep(1);
    // setTimeout(()=>{
    //   setStep(2);
    // },3000)
  },[urlRaw])

  const onClickAdd = useCallback(()=>{
    if(finalUrl) {
      setStep(3)
    }
  },[finalUrl])


  return (
    <>
      <div>
      <div className="mt-4">
        <input className="rounded-lg shadow-xl p-4 text-2xl font-extrabold input-field-primary w-full my-2" placeholder="https://yourdomain.com" onChange={onChangeInput}></input>
        <When condition={error}>
          <div>
            <h3 className="text-red-500 text-base font-bold">{error}</h3>
          </div>
        </When>
      </div>


      <When condition={step === 1}>
      <div className="flex items-center mt-8">
        <h1 className="text-white text-xl font-extrabold text-center">Checking SSL certificate...</h1>
      </div>
      </When>
      {/* <div className="flex items-center mt-8">
        <h1 className="text-white text-xl font-extrabold text-center">Check Certificate for SSL certificate...</h1>
      </div> */}

      <When condition={step === 0}>
        <div className="mt-4">
          <button className="btn-accent mt-1.5 w-full shadow-xl font-bold" onClick={onClickContinue}>Next</button>
        </div>
      </When>
      </div>
      </>
  )
}
